import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

export function MenuIcon({ fill = 'black', size = 'xsmall' }: IconProps) {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 25">
            <path
                className={fillStyles}
                fillRule="evenodd"
                d="M2 12.5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 6.5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 18.5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z"
                clipRule="evenodd"
            />
        </svg>
    );
}
